import {
  AppAside,
  AppBreadcrumb2 as AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebarToggler,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav2 as AppSidebarNav,
} from "@coreui/react";
import React, { Component, Suspense } from "react";

import * as router from "react-router-dom";
import { Redirect, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import { loading } from "../../App";
import { selectProductList } from "../../redux/products/productsSelectors";
// routes config
import routes from "../../routes";
// sidebar nav config
import navigation from "../../_nav";

const DefaultAside = React.lazy(() => import("./DefaultAside"));
const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));

class DefaultLayout extends Component {
  state = {
    currentLocation: "Products",
    isEditing: false,
  };

  setCurrentLocation = (location) => {
    this.setState({ currentLocation: location });
  };

  setIsEditing = (value) => {
    this.setState({ isEditing: value });
  };

  signOut(e) {
    e.preventDefault();
    this.props.history.push("/login");
  }

  render() {
    return (
      <div className="app">
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <Suspense fallback={loading()}>
              <AppSidebarNav
                navConfig={navigation}
                {...this.props}
                router={router}
              />
            </Suspense>
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>

          <main className="main">
            <AppHeader className="sticky-top">
              <Suspense fallback={loading()}>
                <DefaultHeader
                  onLogout={(e) => this.signOut(e)}
                  location={this.state.currentLocation}
                />
              </Suspense>
            </AppHeader>

            <Container fluid className="pt-3">
              <Suspense fallback={loading()}>
                <Switch>
                  {routes.map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={(props) => (
                          <route.component
                            {...props}
                            location={route.name}
                            setCurrentLocation={this.setCurrentLocation}
                          />
                        )}
                      />
                    ) : null;
                  })}
                  <Redirect from="/" to="/pim/products" />
                </Switch>
              </Suspense>
            </Container>
          </main>
          <AppAside fixed>
            <Suspense fallback={loading()}>
              <DefaultAside />
            </Suspense>
          </AppAside>
        </div>
        <AppFooter>
          <Suspense fallback={loading()}>
            <DefaultFooter />
          </Suspense>
        </AppFooter>
      </div>
    );
  }
}

export default DefaultLayout;
